import { gql } from '@apollo/client';

export default gql`
  query getSeatingData($serviceId: String!, $destination: String!, $origin: String!, $travelDate: String!) {
    getSeatingData(serviceId: $serviceId, destination: $destination, origin: $origin, travelDate: $travelDate) {
      reversed
      carriages {
        template
        carriageName
        carriageNumber
        seatWidth
        seatHeight
        sequenceNumber
        reversed
        blocked
        blockedReason
        inventoryClasses
        seats {
          number
          inventoryClass
          reversed
          xPos
          yPos
          available
          allocated
          blocked
          propertyCodes
        }
      }
      seatProperties {
        code
        description
        availableSeats
      }
    }
  }
`;
